import { Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import { ElementRef, useEffect, useRef } from 'react';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

const Infographics = ({ fields, rendering }: ComponentProps) => {
  const { anchorId } = useHelpers(rendering);
  const infographicRef = useRef<ElementRef<'div'>>();
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor = sitecoreContext.pageEditing;

  useEffect(() => {
    if (fields?.source?.value && infographicRef.current) {
      const script = document.createElement('script');
      script.src = fields?.source?.value;
      script.id = fields.id.value;
      script.type = 'text/javascript';
      infographicRef.current.appendChild(script);
    }
  }, [fields?.source?.value, fields.id.value]);

  return (
    (fields.title || isExperienceEditor) && (
      <div
        id={anchorId}
        ref={infographicRef}
        data-e2e-component-uid={rendering.uid}
        style={{ width: '100%' }}
        className={isExperienceEditor ? 'experience-editor-holder' : ''}
      >
        {(fields.title || isExperienceEditor) && (
          <Text
            tag="p"
            className="mb-2 text-grey background-to-change"
            field={fields.title}
            style={{ fontWeight: 700 }}
          />
        )}
      </div>
    )
  );
};

export default withDatasourceCheck()(Infographics);
